var items = {
  "block.minecraft.air": "gaiss",
  "block.minecraft.stone": "akmens",
  "block.minecraft.granite": "granīts",
  "block.minecraft.polished_granite": "pulēts granīts",
  "block.minecraft.diorite": "diorīts",
  "block.minecraft.polished_diorite": "pulēts diorīts",
  "block.minecraft.andesite": "andesīts",
  "block.minecraft.polished_andesite": "pulēts andesīts",
  "block.minecraft.grass_block": "zāles bloks",
  "block.minecraft.dirt": "zeme",
  "block.minecraft.coarse_dirt": "rupja zeme",
  "block.minecraft.podzol": "podzols",
  "block.minecraft.crimson_nylium": "sārtais nīlijs",
  "block.minecraft.warped_nylium": "deformētais nīlijs",
  "block.minecraft.cobblestone": "bruģakmens",
  "block.minecraft.oak_planks": "ozolkoka dēļi",
  "block.minecraft.spruce_planks": "egles dēļi",
  "block.minecraft.birch_planks": "bērza dēļi",
  "block.minecraft.jungle_planks": "džungļu koka dēļi",
  "block.minecraft.acacia_planks": "akācijas dēļi",
  "block.minecraft.dark_oak_planks": "tumšā ozolkoka dēļi",
  "block.minecraft.crimson_planks": "tumšsarkanie dēļi",
  "block.minecraft.warped_planks": "izlocītie dēļi",
  "block.minecraft.oak_sapling": "ozola stāds",
  "block.minecraft.spruce_sapling": "egles stāds",
  "block.minecraft.birch_sapling": "bērza stāds",
  "block.minecraft.jungle_sapling": "džungļu koka stāds",
  "block.minecraft.acacia_sapling": "akācijas stāds",
  "block.minecraft.dark_oak_sapling": "tumšā ozola stāds",
  "block.minecraft.bedrock": "pamatiezis",
  "block.minecraft.sand": "smiltis",
  "block.minecraft.red_sand": "sarkanās smiltis",
  "block.minecraft.gravel": "grants",
  "block.minecraft.gold_ore": "zelta rūda",
  "block.minecraft.iron_ore": "dzelzs rūda",
  "block.minecraft.coal_ore": "akmeņogles",
  "block.minecraft.nether_gold_ore": "nether zelta rūda",
  "block.minecraft.oak_log": "ozola baļķis",
  "block.minecraft.spruce_log": "egles baļķis",
  "block.minecraft.birch_log": "bērza baļķis",
  "block.minecraft.jungle_log": "džungļu koka baļķis",
  "block.minecraft.acacia_log": "akācijas baļķis",
  "block.minecraft.dark_oak_log": "tumšā ozolkoka baļķis",
  "block.minecraft.crimson_stem": "tumšsarkans kāts",
  "block.minecraft.warped_stem": "savērptais kāts",
  "block.minecraft.stripped_oak_log": "nomizots ozola baļķis",
  "block.minecraft.stripped_spruce_log": "nomizots egles baļķis",
  "block.minecraft.stripped_birch_log": "nomizots bērza baļķis",
  "block.minecraft.stripped_jungle_log": "nomizots džungļu koka baļķis",
  "block.minecraft.stripped_acacia_log": "nomizots akācijas baļķis",
  "block.minecraft.stripped_dark_oak_log": "nomizots tumšā ozola baļķis",
  "block.minecraft.stripped_crimson_stem": "nomizots tumšsarkanais kāts",
  "block.minecraft.stripped_warped_stem": "nomizots izlocīts kāts",
  "block.minecraft.stripped_oak_wood": "nomizots ozolkoks",
  "block.minecraft.stripped_spruce_wood": "nomizots egles koks",
  "block.minecraft.stripped_birch_wood": "nomizots bērza koks",
  "block.minecraft.stripped_jungle_wood": "nomizots džungļu koks",
  "block.minecraft.stripped_acacia_wood": "nomizots akācijas koks",
  "block.minecraft.stripped_dark_oak_wood": "nomizots tumšais ozolkoks",
  "block.minecraft.stripped_crimson_hyphae": "nolobītas tumšsarkanās hifas",
  "block.minecraft.stripped_warped_hyphae": "nomizotas izlocītas hifas",
  "block.minecraft.oak_wood": "ozolkoks",
  "block.minecraft.spruce_wood": "egles koks",
  "block.minecraft.birch_wood": "bērza koks",
  "block.minecraft.jungle_wood": "džungļu koks",
  "block.minecraft.acacia_wood": "akācijas koks",
  "block.minecraft.dark_oak_wood": "tumšais ozolkoks",
  "block.minecraft.crimson_hyphae": "tumšsarkanās hifas",
  "block.minecraft.warped_hyphae": "savērptas hifas",
  "block.minecraft.oak_leaves": "ozola lapas",
  "block.minecraft.spruce_leaves": "egles lapas",
  "block.minecraft.birch_leaves": "bērza lapas",
  "block.minecraft.jungle_leaves": "džungļu koka lapas",
  "block.minecraft.acacia_leaves": "akācijas lapas",
  "block.minecraft.dark_oak_leaves": "tumšā ozola lapas",
  "block.minecraft.sponge": "sūklis",
  "block.minecraft.wet_sponge": "mitrs sūklis",
  "block.minecraft.glass": "stikls",
  "block.minecraft.lapis_ore": "lazurīta rūda",
  "block.minecraft.lapis_block": "lazurīta bloks",
  "block.minecraft.dispenser": "izšāvējs",
  "block.minecraft.sandstone": "smilšakmens",
  "block.minecraft.chiseled_sandstone": "noslīpēts smilšakmens",
  "block.minecraft.cut_sandstone": "griezts smilšakmens",
  "block.minecraft.note_block": "nošu bloks",
  "block.minecraft.powered_rail": "elektriskās sliedes",
  "block.minecraft.detector_rail": "detektorsliedes",
  "block.minecraft.sticky_piston": "lipīgs virzulis",
  "block.minecraft.cobweb": "zirnekļtīkls",
  "block.minecraft.grass": "zāle",
  "block.minecraft.fern": "paparde",
  "block.minecraft.dead_bush": "nokaltis krūms",
  "block.minecraft.seagrass": "jūraszāle",
  "block.minecraft.sea_pickle": "jūras gurķis",
  "block.minecraft.piston": "virzulis",
  "block.minecraft.white_wool": "balta vilna",
  "block.minecraft.orange_wool": "oranža vilna",
  "block.minecraft.magenta_wool": "fuksīna vilna",
  "block.minecraft.light_blue_wool": "gaiši zila vilna",
  "block.minecraft.yellow_wool": "dzeltena vilna",
  "block.minecraft.lime_wool": "gaiši zaļa vilna",
  "block.minecraft.pink_wool": "rozā vilna",
  "block.minecraft.gray_wool": "pelēka vilna",
  "block.minecraft.light_gray_wool": "gaiši pelēka vilna",
  "block.minecraft.cyan_wool": "ciāna vilna",
  "block.minecraft.purple_wool": "violeta vilna",
  "block.minecraft.blue_wool": "zila vilna",
  "block.minecraft.brown_wool": "brūna vilna",
  "block.minecraft.green_wool": "zaļa vilna",
  "block.minecraft.red_wool": "sarkana vilna",
  "block.minecraft.black_wool": "melna vilna",
  "block.minecraft.dandelion": "pienene",
  "block.minecraft.poppy": "magone",
  "block.minecraft.blue_orchid": "zila orhideja",
  "block.minecraft.allium": "sīpols",
  "block.minecraft.azure_bluet": "azure rudzupuķe",
  "block.minecraft.red_tulip": "sarkana tulpe",
  "block.minecraft.orange_tulip": "oranža tulpe",
  "block.minecraft.white_tulip": "balta tulpe",
  "block.minecraft.pink_tulip": "rozā tulpe",
  "block.minecraft.oxeye_daisy": "margrietiņa",
  "block.minecraft.cornflower": "rudzupuķe",
  "block.minecraft.lily_of_the_valley": "maijpuķīte",
  "block.minecraft.wither_rose": "wither roze",
  "block.minecraft.brown_mushroom": "brūna sēne",
  "block.minecraft.red_mushroom": "sarkana sēne",
  "block.minecraft.crimson_fungus": "tumšsarkana sēne",
  "block.minecraft.warped_fungus": "izlocīta sēne",
  "block.minecraft.crimson_roots": "tumšsarkanās saknes",
  "block.minecraft.warped_roots": "izlocītas saknes",
  "block.minecraft.nether_sprouts": "nether asni",
  "block.minecraft.weeping_vines": "raudošs vīteņaugs",
  "block.minecraft.twisting_vines": "sagrozītais vīteņaugs",
  "block.minecraft.sugar_cane": "cukurniedres",
  "block.minecraft.kelp": "brūnaļģe",
  "block.minecraft.bamboo": "bambuss",
  "block.minecraft.gold_block": "zelta bloks",
  "block.minecraft.iron_block": "dzelzs bloks",
  "block.minecraft.oak_slab": "ozolkoka plāksne",
  "block.minecraft.spruce_slab": "egles plāksne",
  "block.minecraft.birch_slab": "bērza plāksne",
  "block.minecraft.jungle_slab": "džungļu koka plāksne",
  "block.minecraft.acacia_slab": "akācijas plāksne",
  "block.minecraft.dark_oak_slab": "tumšā ozolkoka plāksne",
  "block.minecraft.crimson_slab": "tumšsarkana plāksne",
  "block.minecraft.warped_slab": "dīvainā plāksne",
  "block.minecraft.stone_slab": "akmens plāksne",
  "block.minecraft.smooth_stone_slab": "gludā akmens plāksne",
  "block.minecraft.sandstone_slab": "smilšakmens plāksne",
  "block.minecraft.cut_sandstone_slab": "griezta smilšakmens plāksne",
  "block.minecraft.petrified_oak_slab": "pārakmeņojisies ozolkoka plāksne",
  "block.minecraft.cobblestone_slab": "bruģakmens plāksne",
  "block.minecraft.brick_slab": "ķieģeļu plāksne",
  "block.minecraft.stone_brick_slab": "akmens ķieģeļu plāksne",
  "block.minecraft.nether_brick_slab": "nether ķieģeļu plāksne",
  "block.minecraft.quartz_slab": "kvarca plāksne",
  "block.minecraft.red_sandstone_slab": "sarkanā smilšakmens plāksne",
  "block.minecraft.cut_red_sandstone_slab": "griezta sarkanā smilšakmens plāksne",
  "block.minecraft.purpur_slab": "purpūra plāksne",
  "block.minecraft.prismarine_slab": "prizmarīna plāksne",
  "block.minecraft.prismarine_brick_slab": "prizmarīna ķieģeļu plāksne",
  "block.minecraft.dark_prismarine_slab": "tumšā prizmarīna plāksne",
  "block.minecraft.smooth_quartz": "gludais kvarca bloks",
  "block.minecraft.smooth_red_sandstone": "gludais sarkanais smilšakmens",
  "block.minecraft.smooth_sandstone": "gludais smilšakmems",
  "block.minecraft.smooth_stone": "gludais akmens",
  "block.minecraft.bricks": "ķieģeļi",
  "block.minecraft.tnt": "dinamīts",
  "block.minecraft.bookshelf": "grāmatu plaukts",
  "block.minecraft.mossy_cobblestone": "apsūnojis bruģakmens",
  "block.minecraft.obsidian": "obsidiāns",
  "block.minecraft.torch": "lāpa",
  "block.minecraft.end_rod": "end stienis",
  "block.minecraft.chorus_plant": "kora augs",
  "block.minecraft.chorus_flower": "kora zieds",
  "block.minecraft.purpur_block": "purpūra bloks",
  "block.minecraft.purpur_pillar": "purpūra pīlārs",
  "block.minecraft.purpur_stairs": "purpūra kāpnes",
  "block.minecraft.spawner": "izsaucējs",
  "block.minecraft.oak_stairs": "ozolkoka kāpnes",
  "block.minecraft.chest": "lāde",
  "block.minecraft.diamond_ore": "dimanta rūda",
  "block.minecraft.diamond_block": "dimantu bloks",
  "block.minecraft.crafting_table": "darbagalds",
  "block.minecraft.farmland": "aramzeme",
  "block.minecraft.furnace": "krāsns",
  "block.minecraft.ladder": "kāpnes",
  "block.minecraft.rail": "sliedes",
  "block.minecraft.cobblestone_stairs": "bruģakmens kāpnes",
  "block.minecraft.lever": "svira",
  "block.minecraft.stone_pressure_plate": "akmens spiediena plātne",
  "block.minecraft.oak_pressure_plate": "ozolkoka spiediena plātne",
  "block.minecraft.spruce_pressure_plate": "egles spiediena plātne",
  "block.minecraft.birch_pressure_plate": "bērza spiediena plātne",
  "block.minecraft.jungle_pressure_plate": "džungļu koka spiediena plātne",
  "block.minecraft.acacia_pressure_plate": "akācijas spiediena plātne",
  "block.minecraft.dark_oak_pressure_plate": "tumšā ozolkoka spiediena plātne",
  "block.minecraft.crimson_pressure_plate": "tumšsarkana spiediena plāksne",
  "block.minecraft.warped_pressure_plate": "izlocīta spiediena plāksne",
  "block.minecraft.polished_blackstone_pressure_plate": "pulēta melnakmens spiediena plāksne",
  "block.minecraft.redstone_ore": "redstone rūda",
  "block.minecraft.redstone_torch": "redstone lāpa",
  "block.minecraft.snow": "sniegs",
  "block.minecraft.ice": "ledus",
  "block.minecraft.snow_block": "sniega bloks",
  "block.minecraft.cactus": "kaktuss",
  "block.minecraft.clay": "māls",
  "block.minecraft.jukebox": "plašu atskaņotājs",
  "block.minecraft.oak_fence": "ozolkoka žogs",
  "block.minecraft.spruce_fence": "egles žogs",
  "block.minecraft.birch_fence": "bērza žogs",
  "block.minecraft.jungle_fence": "džungļu koka žogs",
  "block.minecraft.acacia_fence": "akācijas koka žogs",
  "block.minecraft.dark_oak_fence": "tumšā ozolkoka žogs",
  "block.minecraft.crimson_fence": "tumšsarkans žogs",
  "block.minecraft.warped_fence": "dīvains žogs",
  "block.minecraft.pumpkin": "ķirbis",
  "block.minecraft.carved_pumpkin": "izgrebts ķirbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "dvēseļu smiltis",
  "block.minecraft.soul_soil": "dvēseļu augsne",
  "block.minecraft.basalt": "bazalts",
  "block.minecraft.polished_basalt": "nospodrinātais bazalts",
  "block.minecraft.soul_torch": "dvēseļu lāpa",
  "block.minecraft.glowstone": "mirdzakmens",
  "block.minecraft.jack_o_lantern": "ķirbja laterna",
  "block.minecraft.oak_trapdoor": "ozolkoka lūka",
  "block.minecraft.spruce_trapdoor": "egles lūka",
  "block.minecraft.birch_trapdoor": "bērza lūka",
  "block.minecraft.jungle_trapdoor": "džungļu lūka",
  "block.minecraft.acacia_trapdoor": "akācijas lūka",
  "block.minecraft.dark_oak_trapdoor": "tumšā ozolkoka lūka",
  "block.minecraft.crimson_trapdoor": "tumšsarkana lūka",
  "block.minecraft.warped_trapdoor": "dīvaina lūka",
  "block.minecraft.infested_stone": "inficēts akmens",
  "block.minecraft.infested_cobblestone": "inficēts bruģakmens",
  "block.minecraft.infested_stone_bricks": "inficēti akmens ķieģeļi",
  "block.minecraft.infested_mossy_stone_bricks": "inficēti apsūnojuši akmens ķieģeļi",
  "block.minecraft.infested_cracked_stone_bricks": "inficēti saplaisājuši akmens ķieģeļi",
  "block.minecraft.infested_chiseled_stone_bricks": "inficēti noslīpēti akmens ķieģeļi",
  "block.minecraft.stone_bricks": "akmens ķieģeļi",
  "block.minecraft.mossy_stone_bricks": "apsūnojuši akmens ķieģeļi",
  "block.minecraft.cracked_stone_bricks": "saplaisājuši akmens ķieģeļi",
  "block.minecraft.chiseled_stone_bricks": "noslīpēti akmens ķieģeļi",
  "block.minecraft.brown_mushroom_block": "brūno sēņu bloks",
  "block.minecraft.red_mushroom_block": "sarkano sēņu bloks",
  "block.minecraft.mushroom_stem": "sēnes kāts",
  "block.minecraft.iron_bars": "dzelzs restes",
  "block.minecraft.chain": "ķēde",
  "block.minecraft.glass_pane": "stikla plāksne",
  "block.minecraft.melon": "arbūzs",
  "block.minecraft.vine": "vītenes",
  "block.minecraft.oak_fence_gate": "ozolkoka žoga vārti",
  "block.minecraft.spruce_fence_gate": "egles žoga vārti",
  "block.minecraft.birch_fence_gate": "bērza žoga vārti",
  "block.minecraft.jungle_fence_gate": "džungļu žoga vārti",
  "block.minecraft.acacia_fence_gate": "akācijas žoga vārti",
  "block.minecraft.dark_oak_fence_gate": "tumšā ozolkoka žoga vārti",
  "block.minecraft.crimson_fence_gate": "tumšsarkanas žoga durvis",
  "block.minecraft.warped_fence_gate": "izlocīta žoga vārti",
  "block.minecraft.brick_stairs": "ķieģeļu kāpnes",
  "block.minecraft.stone_brick_stairs": "akmens ķieģeļu kāpnes",
  "block.minecraft.mycelium": "micēlijs",
  "block.minecraft.lily_pad": "ūdensrozes",
  "block.minecraft.nether_bricks": "nether ķieģeļi",
  "block.minecraft.cracked_nether_bricks": "ieplaisājuši nether ķieģeļi",
  "block.minecraft.chiseled_nether_bricks": "slīpēti nether ķieģeļi",
  "block.minecraft.nether_brick_fence": "nether ķieģeļu mūris",
  "block.minecraft.nether_brick_stairs": "nether ķieģeļu kāpnes",
  "block.minecraft.enchanting_table": "burvestību galds",
  "block.minecraft.end_portal_frame": "end portāla rāmis",
  "block.minecraft.end_stone": "end akmens",
  "block.minecraft.end_stone_bricks": "end akmens ķieģeļi",
  "block.minecraft.dragon_egg": "pūķa ola",
  "block.minecraft.redstone_lamp": "redstone lampa",
  "block.minecraft.sandstone_stairs": "smilšakmens kāpnes",
  "block.minecraft.emerald_ore": "smaragda rūda",
  "block.minecraft.ender_chest": "ender lāde",
  "block.minecraft.tripwire_hook": "lamatu āķis",
  "block.minecraft.emerald_block": "smaragda bloks",
  "block.minecraft.spruce_stairs": "egles kāpnes",
  "block.minecraft.birch_stairs": "bērza kāpnes",
  "block.minecraft.jungle_stairs": "džungļu koka kāpnes",
  "block.minecraft.crimson_stairs": "tumšsarkanas kāpnes",
  "block.minecraft.warped_stairs": "izlocītas kāpnes",
  "block.minecraft.command_block": "komandu bloks",
  "block.minecraft.beacon": "bāka",
  "block.minecraft.cobblestone_wall": "bruģakmens mūris",
  "block.minecraft.mossy_cobblestone_wall": "apsūnojis bruģakmens mūris",
  "block.minecraft.brick_wall": "ķieģeļu mūris",
  "block.minecraft.prismarine_wall": "prizmarīna mūris",
  "block.minecraft.red_sandstone_wall": "sarkanā smilšakmens mūris",
  "block.minecraft.mossy_stone_brick_wall": "apsūnojušu akmens ķieģeļu mūris",
  "block.minecraft.granite_wall": "granīta mūris",
  "block.minecraft.stone_brick_wall": "akmens ķieģeļu mūris",
  "block.minecraft.nether_brick_wall": "nether ķieģeļu mūris",
  "block.minecraft.andesite_wall": "andesīta mūris",
  "block.minecraft.red_nether_brick_wall": "sarkano nether ķieģeļu mūris",
  "block.minecraft.sandstone_wall": "smilšakmens mūris",
  "block.minecraft.end_stone_brick_wall": "end akmens ķieģeļu mūris",
  "block.minecraft.diorite_wall": "diorīta mūris",
  "block.minecraft.blackstone_wall": "melnakmens mūris",
  "block.minecraft.polished_blackstone_wall": "pulēta melnakmens mūris",
  "block.minecraft.polished_blackstone_brick_wall": "pulētu melnakmens ķieģeļu mūris",
  "block.minecraft.stone_button": "akmens poga",
  "block.minecraft.oak_button": "ozolkoka poga",
  "block.minecraft.spruce_button": "egles poga",
  "block.minecraft.birch_button": "bērza poga",
  "block.minecraft.jungle_button": "džungļu koka poga",
  "block.minecraft.acacia_button": "akācijas poga",
  "block.minecraft.dark_oak_button": "tumšā ozolkoka poga",
  "block.minecraft.crimson_button": "tumšsarkana poga",
  "block.minecraft.warped_button": "dīvaina poga",
  "block.minecraft.polished_blackstone_button": "pulēta melnakmens poga",
  "block.minecraft.anvil": "lakta",
  "block.minecraft.chipped_anvil": "apdauzīta lakta",
  "block.minecraft.damaged_anvil": "bojāta lakta",
  "block.minecraft.trapped_chest": "lamatu lāde",
  "block.minecraft.light_weighted_pressure_plate": "viegla spiediena plātne",
  "block.minecraft.heavy_weighted_pressure_plate": "smaga spiediena plātne",
  "block.minecraft.daylight_detector": "dienasgaismas detektors",
  "block.minecraft.redstone_block": "redstone bloks",
  "block.minecraft.nether_quartz_ore": "nether kvarca rūda",
  "block.minecraft.hopper": "piltuve",
  "block.minecraft.chiseled_quartz_block": "slīpēts kvarca bloks",
  "block.minecraft.quartz_block": "kvarca bloks",
  "block.minecraft.quartz_bricks": "kvarca ķieģeļi",
  "block.minecraft.quartz_pillar": "kvarca pīlārs",
  "block.minecraft.quartz_stairs": "kvarca kāpnes",
  "block.minecraft.activator_rail": "aktivatora sliedes",
  "block.minecraft.dropper": "izsviedējs",
  "block.minecraft.white_terracotta": "balta terakota",
  "block.minecraft.orange_terracotta": "oranža terakota",
  "block.minecraft.magenta_terracotta": "fuksīna terakota",
  "block.minecraft.light_blue_terracotta": "gaiši zila terakota",
  "block.minecraft.yellow_terracotta": "dzeltena terakota",
  "block.minecraft.lime_terracotta": "gaiši zaļa terakota",
  "block.minecraft.pink_terracotta": "rozā terakota",
  "block.minecraft.gray_terracotta": "pelēka terakota",
  "block.minecraft.light_gray_terracotta": "gaiši pelēka terakota",
  "block.minecraft.cyan_terracotta": "ciāna terakota",
  "block.minecraft.purple_terracotta": "violeta terakota",
  "block.minecraft.blue_terracotta": "zila terakota",
  "block.minecraft.brown_terracotta": "brūna terakota",
  "block.minecraft.green_terracotta": "zaļa terakota",
  "block.minecraft.red_terracotta": "sarkana terakota",
  "block.minecraft.black_terracotta": "melna terakota",
  "block.minecraft.barrier": "barjera",
  "block.minecraft.iron_trapdoor": "dzelzs lūka",
  "block.minecraft.hay_block": "siena ķīpa",
  "block.minecraft.white_carpet": "balts paklājs",
  "block.minecraft.orange_carpet": "oranžs paklājs",
  "block.minecraft.magenta_carpet": "fuksīns paklājs",
  "block.minecraft.light_blue_carpet": "gaiši zils paklājs",
  "block.minecraft.yellow_carpet": "dzeltens paklājs",
  "block.minecraft.lime_carpet": "gaiši zaļš paklājs",
  "block.minecraft.pink_carpet": "rozā paklājs",
  "block.minecraft.gray_carpet": "pelēks paklājs",
  "block.minecraft.light_gray_carpet": "gaiši pelēks paklājs",
  "block.minecraft.cyan_carpet": "ciāns paklājs",
  "block.minecraft.purple_carpet": "violets paklājs",
  "block.minecraft.blue_carpet": "zils paklājs",
  "block.minecraft.brown_carpet": "brūns paklājs",
  "block.minecraft.green_carpet": "zaļš paklājs",
  "block.minecraft.red_carpet": "sarkans paklājs",
  "block.minecraft.black_carpet": "melns paklājs",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "ogļu bloks",
  "block.minecraft.packed_ice": "pakots ledus",
  "block.minecraft.acacia_stairs": "akācijas kāpnes",
  "block.minecraft.dark_oak_stairs": "tumšā ozolkoka kāpnes",
  "block.minecraft.slime_block": "gļotu bloks",
  "block.minecraft.grass_path": "zāles taka",
  "block.minecraft.sunflower": "saulespuķe",
  "block.minecraft.lilac": "ceriņi",
  "block.minecraft.rose_bush": "rožu krūms",
  "block.minecraft.peony": "peonija",
  "block.minecraft.tall_grass": "gara zāle",
  "block.minecraft.large_fern": "liela paparde",
  "block.minecraft.white_stained_glass": "balts krāsots stikls",
  "block.minecraft.orange_stained_glass": "oranžs krāsots stikls",
  "block.minecraft.magenta_stained_glass": "fuksīns krāsots stikls",
  "block.minecraft.light_blue_stained_glass": "gaiši zils krāsots stikls",
  "block.minecraft.yellow_stained_glass": "dzeltens krāsots stikls",
  "block.minecraft.lime_stained_glass": "gaiši zaļš krāsots stikls",
  "block.minecraft.pink_stained_glass": "rozā krāsots stikls",
  "block.minecraft.gray_stained_glass": "pelēks krāsots stikls",
  "block.minecraft.light_gray_stained_glass": "gaiši pelēks krāsots stikls",
  "block.minecraft.cyan_stained_glass": "ciāns krāsots stikls",
  "block.minecraft.purple_stained_glass": "violets krāsots stikls",
  "block.minecraft.blue_stained_glass": "zils krāsots stikls",
  "block.minecraft.brown_stained_glass": "brūns krāsots stikls",
  "block.minecraft.green_stained_glass": "zaļš krāsots stikls",
  "block.minecraft.red_stained_glass": "sarkans krāsots stikls",
  "block.minecraft.black_stained_glass": "melns krāsots stikls",
  "block.minecraft.white_stained_glass_pane": "balta krāsota stikla plāksne",
  "block.minecraft.orange_stained_glass_pane": "oranža krāsota stikla plāksne",
  "block.minecraft.magenta_stained_glass_pane": "fuksīna krāsota stikla plāksne",
  "block.minecraft.light_blue_stained_glass_pane": "gaiši zila krāsota stikla plāksne",
  "block.minecraft.yellow_stained_glass_pane": "dzeltena krāsota stikla plāksne",
  "block.minecraft.lime_stained_glass_pane": "gaiši zaļa krāsota stikla plāksne",
  "block.minecraft.pink_stained_glass_pane": "rozā krāsota stikla plāksne",
  "block.minecraft.gray_stained_glass_pane": "pelēka krāsota stikla plāksne",
  "block.minecraft.light_gray_stained_glass_pane": "gaiši pelēka krāsota stikla plāksne",
  "block.minecraft.cyan_stained_glass_pane": "ciāna krāsota stikla plāksne",
  "block.minecraft.purple_stained_glass_pane": "violeta krāsota stikla plāksne",
  "block.minecraft.blue_stained_glass_pane": "zila krāsota stikla plāksne",
  "block.minecraft.brown_stained_glass_pane": "brūna krāsota stikla plāksne",
  "block.minecraft.green_stained_glass_pane": "zaļa krāsota stikla plāksne",
  "block.minecraft.red_stained_glass_pane": "sarkana krāsota stikla plāksne",
  "block.minecraft.black_stained_glass_pane": "melna krāsota stikla plāksne",
  "block.minecraft.prismarine": "prizmarīns",
  "block.minecraft.prismarine_bricks": "prizmarīna ķieģeļi",
  "block.minecraft.dark_prismarine": "tumšais prizmarīns",
  "block.minecraft.prismarine_stairs": "prizmarīna kāpnes",
  "block.minecraft.prismarine_brick_stairs": "prizmarīna kieģeļu kāpnes",
  "block.minecraft.dark_prismarine_stairs": "tumšā prizmarīna kāpnes",
  "block.minecraft.sea_lantern": "jūras laterna",
  "block.minecraft.red_sandstone": "sarkanais smilšakmens",
  "block.minecraft.chiseled_red_sandstone": "slīpēts sarkanais smilšakmens",
  "block.minecraft.cut_red_sandstone": "griezts sarkanais smilšakmens",
  "block.minecraft.red_sandstone_stairs": "sarkanā smilšakmens kāpnes",
  "block.minecraft.repeating_command_block": "atkārtojošais komandu bloks",
  "block.minecraft.chain_command_block": "ķēdes komandu bloks",
  "block.minecraft.magma_block": "magmas bloks",
  "block.minecraft.nether_wart_block": "nether kārpu bloks",
  "block.minecraft.warped_wart_block": "izlocīts kārpu bloks",
  "block.minecraft.red_nether_bricks": "sarkanie nether ķieģeļi",
  "block.minecraft.bone_block": "kaulu bloks",
  "block.minecraft.structure_void": "struktūras tukšums",
  "block.minecraft.observer": "novērotājs",
  "block.minecraft.shulker_box": "šulkera kaste",
  "block.minecraft.white_shulker_box": "balta šulkera kaste",
  "block.minecraft.orange_shulker_box": "oranža šulkera kaste",
  "block.minecraft.magenta_shulker_box": "fuksīna šulkera kaste",
  "block.minecraft.light_blue_shulker_box": "gaiši zila šulkera kaste",
  "block.minecraft.yellow_shulker_box": "dzeltena šulkera kaste",
  "block.minecraft.lime_shulker_box": "gaiši zaļa šulkera kaste",
  "block.minecraft.pink_shulker_box": "rozā šulkera kaste",
  "block.minecraft.gray_shulker_box": "pelēka šulkera kaste",
  "block.minecraft.light_gray_shulker_box": "gaiši pelēka šulkera kaste",
  "block.minecraft.cyan_shulker_box": "ciāna šulkera kaste",
  "block.minecraft.purple_shulker_box": "violeta šulkera kaste",
  "block.minecraft.blue_shulker_box": "zila šulkera kaste",
  "block.minecraft.brown_shulker_box": "brūna šulkera kaste",
  "block.minecraft.green_shulker_box": "zaļa šulkera kaste",
  "block.minecraft.red_shulker_box": "sarkana šulkera kaste",
  "block.minecraft.black_shulker_box": "melna šulkera kaste",
  "block.minecraft.white_glazed_terracotta": "balta glazēta terakota",
  "block.minecraft.orange_glazed_terracotta": "oranža glazēta terakota",
  "block.minecraft.magenta_glazed_terracotta": "fuksīna glazēta terakota",
  "block.minecraft.light_blue_glazed_terracotta": "gaiši zila glazēta terakota",
  "block.minecraft.yellow_glazed_terracotta": "dzeltena glazēta terakota",
  "block.minecraft.lime_glazed_terracotta": "gaiši zaļa glazēta terakota",
  "block.minecraft.pink_glazed_terracotta": "rozā glazēta terakota",
  "block.minecraft.gray_glazed_terracotta": "pelēka glazēta terakota",
  "block.minecraft.light_gray_glazed_terracotta": "gaiši pelēka glazēta terakota",
  "block.minecraft.cyan_glazed_terracotta": "ciāna glazēta terakota",
  "block.minecraft.purple_glazed_terracotta": "violeta glazēta terakota",
  "block.minecraft.blue_glazed_terracotta": "zila glazēta terakota",
  "block.minecraft.brown_glazed_terracotta": "brūna glazēta terakota",
  "block.minecraft.green_glazed_terracotta": "zaļa glazēta terakota",
  "block.minecraft.red_glazed_terracotta": "sarkana glazēta terakota",
  "block.minecraft.black_glazed_terracotta": "melna glazēta terakota",
  "block.minecraft.white_concrete": "balts betons",
  "block.minecraft.orange_concrete": "oranžš betons",
  "block.minecraft.magenta_concrete": "fuksīns betons",
  "block.minecraft.light_blue_concrete": "gaiši zils betons",
  "block.minecraft.yellow_concrete": "dzeltens betons",
  "block.minecraft.lime_concrete": "gaiši zaļš betons",
  "block.minecraft.pink_concrete": "rozā betons",
  "block.minecraft.gray_concrete": "pelēks betons",
  "block.minecraft.light_gray_concrete": "gaiši pelēks betons",
  "block.minecraft.cyan_concrete": "ciāns betons",
  "block.minecraft.purple_concrete": "violets betons",
  "block.minecraft.blue_concrete": "zils betons",
  "block.minecraft.brown_concrete": "brūns betons",
  "block.minecraft.green_concrete": "zaļš betons",
  "block.minecraft.red_concrete": "sarkans betons",
  "block.minecraft.black_concrete": "melns betons",
  "block.minecraft.white_concrete_powder": "balts betona pulveris",
  "block.minecraft.orange_concrete_powder": "oranžs betona pulveris",
  "block.minecraft.magenta_concrete_powder": "fuksīns betona pulveris",
  "block.minecraft.light_blue_concrete_powder": "gaiši zils betona pulveris",
  "block.minecraft.yellow_concrete_powder": "dzeltens betona pulveris",
  "block.minecraft.lime_concrete_powder": "gaiši zaļš betona pulveris",
  "block.minecraft.pink_concrete_powder": "rozā betona pulveris",
  "block.minecraft.gray_concrete_powder": "pelēks betona pulveris",
  "block.minecraft.light_gray_concrete_powder": "gaiši pelēks betona pulveris",
  "block.minecraft.cyan_concrete_powder": "ciāns betona pulveris",
  "block.minecraft.purple_concrete_powder": "violets betona pulveris",
  "block.minecraft.blue_concrete_powder": "zils betona pulveris",
  "block.minecraft.brown_concrete_powder": "brūns betona pulveris",
  "block.minecraft.green_concrete_powder": "zaļš betona pulveris",
  "block.minecraft.red_concrete_powder": "sarkans betona pulveris",
  "block.minecraft.black_concrete_powder": "melns betona pulveris",
  "block.minecraft.turtle_egg": "bruņurupuča ola",
  "block.minecraft.dead_tube_coral_block": "beigts caurules koraļļu bloks",
  "block.minecraft.dead_brain_coral_block": "beigts smadzeņu koraļļu bloks",
  "block.minecraft.dead_bubble_coral_block": "beigts burbuļu koraļļu bloks",
  "block.minecraft.dead_fire_coral_block": "beigts uguns koraļļu bloks",
  "block.minecraft.dead_horn_coral_block": "beigts raga koraļļu bloks",
  "block.minecraft.tube_coral_block": "caurules koraļļu bloks",
  "block.minecraft.brain_coral_block": "smadzeņu koraļļu bloks",
  "block.minecraft.bubble_coral_block": "burbuļu koraļļu bloks",
  "block.minecraft.fire_coral_block": "uguns koraļļu bloks",
  "block.minecraft.horn_coral_block": "raga koraļļu bloks",
  "block.minecraft.tube_coral": "caurules korallis",
  "block.minecraft.brain_coral": "smadzeņu korallis",
  "block.minecraft.bubble_coral": "burbuļu korallis",
  "block.minecraft.fire_coral": "uguns korallis",
  "block.minecraft.horn_coral": "raga korallis",
  "block.minecraft.dead_brain_coral": "beigts smadzeņu korallis",
  "block.minecraft.dead_bubble_coral": "beigts burbuļu korallis",
  "block.minecraft.dead_fire_coral": "beigts uguns korallis",
  "block.minecraft.dead_horn_coral": "beigts raga korallis",
  "block.minecraft.dead_tube_coral": "beigts caurules korallis",
  "block.minecraft.tube_coral_fan": "caurules koraļļa spārns",
  "block.minecraft.brain_coral_fan": "smadzeņu koraļļa spārns",
  "block.minecraft.bubble_coral_fan": "burbuļu koraļļa spārns",
  "block.minecraft.fire_coral_fan": "uguns koraļļa spārns",
  "block.minecraft.horn_coral_fan": "raga koraļļa spārns",
  "block.minecraft.dead_tube_coral_fan": "beigts caurules koraļļa vēdeklis",
  "block.minecraft.dead_brain_coral_fan": "beigts smadzeņu koraļļa vēdeklis",
  "block.minecraft.dead_bubble_coral_fan": "beigts burbuļu koraļļa vēdeklis",
  "block.minecraft.dead_fire_coral_fan": "beigts uguns koraļļa vēdeklis",
  "block.minecraft.dead_horn_coral_fan": "beigts raga koraļļa vēdeklis",
  "block.minecraft.blue_ice": "zilais ledus",
  "block.minecraft.conduit": "konduits",
  "block.minecraft.polished_granite_stairs": "pulētas granīta kāpnes",
  "block.minecraft.smooth_red_sandstone_stairs": "gludas sarkanā smilšakmens kāpnes",
  "block.minecraft.mossy_stone_brick_stairs": "apsūnojušas akmens ķieģeļu kāpnes",
  "block.minecraft.polished_diorite_stairs": "pulētas diorīta kāpnes",
  "block.minecraft.mossy_cobblestone_stairs": "apsūnojušas bruģakmens kāpnes",
  "block.minecraft.end_stone_brick_stairs": "end akmens ķieģeļu kāpnes",
  "block.minecraft.stone_stairs": "akmens kāpnes",
  "block.minecraft.smooth_sandstone_stairs": "gludas smilšakmens kāpnes",
  "block.minecraft.smooth_quartz_stairs": "gludas kvarca kāpnes",
  "block.minecraft.granite_stairs": "granīta kāpnes",
  "block.minecraft.andesite_stairs": "andesīta kāpnes",
  "block.minecraft.red_nether_brick_stairs": "sarkano nether ķieģeļu kāpnes",
  "block.minecraft.polished_andesite_stairs": "pulētas andesīta kāpnes",
  "block.minecraft.diorite_stairs": "diorīta kāpnes",
  "block.minecraft.polished_granite_slab": "pulēta granīta plāksne",
  "block.minecraft.smooth_red_sandstone_slab": "gluda sarkanā smilšakmens plāksne",
  "block.minecraft.mossy_stone_brick_slab": "apsūnojusi akmens ķieģeļu plāksne",
  "block.minecraft.polished_diorite_slab": "pulēta diorīta plāksne",
  "block.minecraft.mossy_cobblestone_slab": "apsūnojusi bruģakmens plāksne",
  "block.minecraft.end_stone_brick_slab": "end akmens ķieģeļu plāksne",
  "block.minecraft.smooth_sandstone_slab": "gluda smilšakmens plāksne",
  "block.minecraft.smooth_quartz_slab": "gluda kvarca plāksne",
  "block.minecraft.granite_slab": "granīta plāksne",
  "block.minecraft.andesite_slab": "andesīta plāksne",
  "block.minecraft.red_nether_brick_slab": "sarkano nether ķieģeļu plāksne",
  "block.minecraft.polished_andesite_slab": "pulēta andesīta plāksne",
  "block.minecraft.diorite_slab": "diorīta plāksne",
  "block.minecraft.scaffolding": "sastatnes",
  "block.minecraft.iron_door": "dzelzs druvis",
  "block.minecraft.oak_door": "ozolkoka durvis",
  "block.minecraft.spruce_door": "egles durvis",
  "block.minecraft.birch_door": "bērza durvis",
  "block.minecraft.jungle_door": "džungļu durvis",
  "block.minecraft.acacia_door": "akāciju durvis",
  "block.minecraft.dark_oak_door": "tumšā ozolkoka durvis",
  "block.minecraft.crimson_door": "tumšsarkanas durvis",
  "block.minecraft.warped_door": "dīvainas durvis",
  "block.minecraft.repeater": "redstone atkārtotājs",
  "block.minecraft.comparator": "redstone salīdzinātājs",
  "block.minecraft.structure_block": "struktūras bloks",
  "block.minecraft.jigsaw": "puzles bloks",
  "item.minecraft.turtle_helmet": "bruņurupuča čaula□□kad uz galvas:□+2 bruņas",
  "item.minecraft.scute": "bruņurupuča bruņas",
  "item.minecraft.iron_shovel": "dzelzs lāpsta□□kad galvenajā rokā:□+3.5 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.iron_pickaxe": "dzelzs cirtnis□□kad galvenajā rokā:□+3 bojājums□-2.8 uzbrukuma ātrums",
  "item.minecraft.iron_axe": "dzelzs cirvis□□kad galvenajā rokā:□+8 bojājums□-3.1 uzbrukuma ātrums",
  "item.minecraft.flint_and_steel": "krams un dzelzs",
  "item.minecraft.apple": "ābols",
  "item.minecraft.bow": "loks",
  "item.minecraft.arrow": "bulta",
  "item.minecraft.coal": "ogles",
  "item.minecraft.charcoal": "kokogles",
  "item.minecraft.diamond": "dimants",
  "item.minecraft.iron_ingot": "dzelzs stienis",
  "item.minecraft.gold_ingot": "zelta stienis",
  "item.minecraft.netherite_ingot": "nezerīta stienis",
  "item.minecraft.netherite_scrap": "nezerīta druska",
  "item.minecraft.iron_sword": "dzelzs zobens□□kad galvenajā rokā:□+5 bojājums□-2.4 uzbrukuma ātrums",
  "item.minecraft.wooden_sword": "koka zobens□□kad galvenajā rokā:□+3 bojājums□-2.4 uzbrukuma ātrums",
  "item.minecraft.wooden_shovel": "koka lāpsta□□kad galvenajā rokā:□+1.5 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.wooden_pickaxe": "koka cirtnis□□kad galvenajā rokā:□+1 bojājums□-2.8 uzbrukuma ātrums",
  "item.minecraft.wooden_axe": "koka cirvis□□kad galvenajā rokā:□+6 bojājums□-3.2 uzbrukuma ātrums",
  "item.minecraft.stone_sword": "akmens zobens□□kad galvenajā rokā:□+4 bojājums□-2.4 uzbrukuma ātrums",
  "item.minecraft.stone_shovel": "akmens lāpsta□□kad galvenajā rokā:□+2.5 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.stone_pickaxe": "akmens cirtnis□□kad galvenajā rokā:□+2 bojājums□-2.8 uzbrukuma ātrums",
  "item.minecraft.stone_axe": "akmens cirvis□□kad galvenajā rokā:□+8 bojājums□-3.2 uzbrukuma ātrums",
  "item.minecraft.diamond_sword": "dimanta zobens□□kad galvenajā rokā:□+6 bojājums□-2.4 uzbrukuma ātrums",
  "item.minecraft.diamond_shovel": "dimanta lāpsta□□kad galvenajā rokā:□+4.5 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.diamond_pickaxe": "dimanta cirtnis□□kad galvenajā rokā:□+4 bojājums□-2.8 uzbrukuma ātrums",
  "item.minecraft.diamond_axe": "dimanta cirvis□□kad galvenajā rokā:□+8 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.stick": "nūja",
  "item.minecraft.bowl": "bļoda",
  "item.minecraft.mushroom_stew": "sēņu zupa",
  "item.minecraft.golden_sword": "zelta zobens□□kad galvenajā rokā:□+3 bojājums□-2.4 uzbrukuma ātrums",
  "item.minecraft.golden_shovel": "zelta lāpsta□□kad galvenajā rokā:□+1.5 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.golden_pickaxe": "zelta cirtnis□□kad galvenajā rokā:□+1 bojājums□-2.8 uzbrukuma ātrums",
  "item.minecraft.golden_axe": "zelta cirvis□□kad galvenajā rokā:□+6 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.netherite_sword": "nezerīta zobens□□kad galvenajā rokā:□+7 bojājums□-2.4 uzbrukuma ātrums",
  "item.minecraft.netherite_shovel": "nezerīta lāpsta□□kad galvenajā rokā:□+5.5 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.netherite_pickaxe": "nezerīta cirtnis□□kad galvenajā rokā:□+5 bojājums□-2.8 uzbrukuma ātrums",
  "item.minecraft.netherite_axe": "nezerīta cirvis□□kad galvenajā rokā:□+9 bojājums□-3 uzbrukuma ātrums",
  "item.minecraft.string": "aukla",
  "item.minecraft.feather": "spalva",
  "item.minecraft.gunpowder": "šaujampulveris",
  "item.minecraft.wooden_hoe": "koka kaplis□□kad galvenajā rokā:□-3 uzbrukuma ātrums",
  "item.minecraft.stone_hoe": "akmens kaplis□□kad galvenajā rokā:□-2 uzbrukuma ātrums",
  "item.minecraft.iron_hoe": "dzelzs kaplis□□kad galvenajā rokā:□-1 uzbrukuma ātrums",
  "item.minecraft.diamond_hoe": "dimanta kaplis□□kad galvenajā rokā:",
  "item.minecraft.golden_hoe": "zelta kaplis□□kad galvenajā rokā:□-3 uzbrukuma ātrums",
  "item.minecraft.netherite_hoe": "nezerīta kaplis□□kad galvenajā rokā:",
  "item.minecraft.wheat_seeds": "kviešu sēklas",
  "item.minecraft.wheat": "kvieši",
  "item.minecraft.bread": "maize",
  "item.minecraft.leather_helmet": "ādas cepure□□kad uz galvas:□+1 bruņas",
  "item.minecraft.leather_chestplate": "ādas jaka□□kad uz ķermeņa:□+3 bruņas",
  "item.minecraft.leather_leggings": "ādas bikses□□kad kājās:□+2 bruņas",
  "item.minecraft.leather_boots": "adas zābaki□□kad uz pēdām:□+1 bruņas",
  "item.minecraft.chainmail_helmet": "ķēžu ķivere□□kad uz galvas:□+2 bruņas",
  "item.minecraft.chainmail_chestplate": "ķēžu bruņas□□kad uz ķermeņa:□+5 bruņas",
  "item.minecraft.chainmail_leggings": "ķēžu bikses□□kad kājās:□+4 bruņas",
  "item.minecraft.chainmail_boots": "ķēžu zābaki□□kad uz pēdām:□+1 bruņas",
  "item.minecraft.iron_helmet": "dzelzs ķivere□□kad uz galvas:□+2 bruņas",
  "item.minecraft.iron_chestplate": "dzelzs bruņas□□kad uz ķermeņa:□+6 bruņas",
  "item.minecraft.iron_leggings": "dzelzs bikses□□kad kājās:□+5 bruņas",
  "item.minecraft.iron_boots": "dzelzs zābaki□□kad uz pēdām:□+2 bruņas",
  "item.minecraft.diamond_helmet": "dimanta ķivere□□kad uz galvas:□+3 bruņas□+2 bruņu stingrība",
  "item.minecraft.diamond_chestplate": "dimanta bruņas□□kad uz ķermeņa:□+8 bruņas□+2 bruņu stingrība",
  "item.minecraft.diamond_leggings": "dimanta bikses□□kad kājās:□+6 bruņas□+2 bruņu stingrība",
  "item.minecraft.diamond_boots": "dimanta zābaki□□kad uz pēdām:□+3 bruņas□+2 bruņu stingrība",
  "item.minecraft.golden_helmet": "zelta ķivere□□kad uz galvas:□+2 bruņas",
  "item.minecraft.golden_chestplate": "zelta bruņas□□kad uz ķermeņa:□+5 bruņas",
  "item.minecraft.golden_leggings": "zelta bikses□□kad kājās:□+3 bruņas",
  "item.minecraft.golden_boots": "zelta zābaki□□kad uz pēdām:□+1 bruņas",
  "item.minecraft.netherite_helmet": "nezerīta ķivere□□kad uz galvas:□+3 bruņas□+3 bruņu stingrība□+1 atpakaļsitiena pretestība",
  "item.minecraft.netherite_chestplate": "nezerīta bruņas□□kad uz ķermeņa:□+8 bruņas□+3 bruņu stingrība□+1 atpakaļsitiena pretestība",
  "item.minecraft.netherite_leggings": "nezerīta bikses□□kad kājās:□+6 bruņas□+3 bruņu stingrība□+1 atpakaļsitiena pretestība",
  "item.minecraft.netherite_boots": "nezerīta zābaki□□kad uz pēdām:□+3 bruņas□+3 bruņu stingrība□+1 atpakaļsitiena pretestība",
  "item.minecraft.flint": "krams",
  "item.minecraft.porkchop": "jēla cūkgaļa",
  "item.minecraft.cooked_porkchop": "cepta cūkgaļa",
  "item.minecraft.painting": "glezna",
  "item.minecraft.golden_apple": "zelta ābols",
  "item.minecraft.enchanted_golden_apple": "uzlabots zelta ābols",
  "block.minecraft.oak_sign": "ozolkoka zīme",
  "block.minecraft.spruce_sign": "egles zīme",
  "block.minecraft.birch_sign": "bērza zīme",
  "block.minecraft.jungle_sign": "džungļu koka zīme",
  "block.minecraft.acacia_sign": "akācijas zīme",
  "block.minecraft.dark_oak_sign": "tumšā ozolkoka zīme",
  "block.minecraft.crimson_sign": "tumšsarkana zīme",
  "block.minecraft.warped_sign": "izlocīta zīme",
  "item.minecraft.bucket": "spainis",
  "item.minecraft.water_bucket": "ūdens spainis",
  "item.minecraft.lava_bucket": "lavas spainis",
  "item.minecraft.minecart": "vagons",
  "item.minecraft.saddle": "segli",
  "item.minecraft.redstone": "redstone putekļi",
  "item.minecraft.snowball": "sniega pika",
  "item.minecraft.oak_boat": "ozolkoka laiva",
  "item.minecraft.leather": "āda",
  "item.minecraft.milk_bucket": "piena spainis",
  "item.minecraft.pufferfish_bucket": "pūšļa zivs spainis",
  "item.minecraft.salmon_bucket": "laša spainis",
  "item.minecraft.cod_bucket": "mencas spainis",
  "item.minecraft.tropical_fish_bucket": "tropiskās zivs spainis",
  "item.minecraft.brick": "ķieģelis",
  "item.minecraft.clay_ball": "māla pika",
  "block.minecraft.dried_kelp_block": "izkaltētu brūnaļģu bloks",
  "item.minecraft.paper": "papīrs",
  "item.minecraft.book": "grāmata",
  "item.minecraft.slime_ball": "gļotu bumba",
  "item.minecraft.chest_minecart": "vagons ar lādi",
  "item.minecraft.furnace_minecart": "vagons ar krāsni",
  "item.minecraft.egg": "ola",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "makšķere",
  "item.minecraft.clock": "pulkstenis",
  "item.minecraft.glowstone_dust": "mirdzakmens putekļi",
  "item.minecraft.cod": "jēla menca",
  "item.minecraft.salmon": "jēls lasis",
  "item.minecraft.tropical_fish": "tropiskā zivs",
  "item.minecraft.pufferfish": "pūšļa zivs",
  "item.minecraft.cooked_cod": "cepta menca",
  "item.minecraft.cooked_salmon": "cepts lasis",
  "item.minecraft.ink_sac": "tintes maisiņš",
  "item.minecraft.red_dye": "sarkana krāsa",
  "item.minecraft.green_dye": "zaļa krāsa",
  "item.minecraft.cocoa_beans": "kakao pupiņas",
  "item.minecraft.lapis_lazuli": "lazurīts",
  "item.minecraft.purple_dye": "violeta krāsa",
  "item.minecraft.cyan_dye": "ciāna krāsa",
  "item.minecraft.light_gray_dye": "gaiši pelēka krāsa",
  "item.minecraft.gray_dye": "pelēka krāsviela",
  "item.minecraft.pink_dye": "rozā krāsa",
  "item.minecraft.lime_dye": "gaiši zaļa krāsa",
  "item.minecraft.yellow_dye": "dzeltena krāsa",
  "item.minecraft.light_blue_dye": "gaiši zila krāsa",
  "item.minecraft.magenta_dye": "fuksīna krāsa",
  "item.minecraft.orange_dye": "oranža krāsa",
  "item.minecraft.bone_meal": "kaulu milti",
  "item.minecraft.blue_dye": "zila krāsa",
  "item.minecraft.brown_dye": "brūna krāsa",
  "item.minecraft.black_dye": "melna krāsa",
  "item.minecraft.white_dye": "balta krāsa",
  "item.minecraft.bone": "kauls",
  "item.minecraft.sugar": "cukurs",
  "block.minecraft.cake": "torte",
  "block.minecraft.white_bed": "balta gulta",
  "block.minecraft.orange_bed": "oranža gulta",
  "block.minecraft.magenta_bed": "fuksīna gulta",
  "block.minecraft.light_blue_bed": "gaiši zila gulta",
  "block.minecraft.yellow_bed": "dzeltena gulta",
  "block.minecraft.lime_bed": "gaiši zaļa gulta",
  "block.minecraft.pink_bed": "rozā gulta",
  "block.minecraft.gray_bed": "pelēka gulta",
  "block.minecraft.light_gray_bed": "gaiši pelēka gulta",
  "block.minecraft.cyan_bed": "ciāna gulta",
  "block.minecraft.purple_bed": "violeta gulta",
  "block.minecraft.blue_bed": "zila gulta",
  "block.minecraft.brown_bed": "brūna gulta",
  "block.minecraft.green_bed": "zaļa gulta",
  "block.minecraft.red_bed": "sarkana gulta",
  "block.minecraft.black_bed": "melna gulta",
  "item.minecraft.cookie": "cepums",
  "item.minecraft.filled_map": "karte□#0",
  "item.minecraft.shears": "šķēres",
  "item.minecraft.melon_slice": "arbūza šķēle",
  "item.minecraft.dried_kelp": "kaltētas brūnaļģes",
  "item.minecraft.pumpkin_seeds": "ķirbju sēklas",
  "item.minecraft.melon_seeds": "arbūza sēklas",
  "item.minecraft.beef": "jēla lielopa gaļa",
  "item.minecraft.cooked_beef": "bifšteks",
  "item.minecraft.chicken": "jēla vista",
  "item.minecraft.cooked_chicken": "cepta vista",
  "item.minecraft.rotten_flesh": "sapuvusi gaļa",
  "item.minecraft.ender_pearl": "ender pērle",
  "item.minecraft.blaze_rod": "liesmu stienis",
  "item.minecraft.ghast_tear": "ghasta asaras",
  "item.minecraft.gold_nugget": "zelta gabals",
  "item.minecraft.nether_wart": "nether kārpa",
  "item.minecraft.potion": "neizveidojama dzira□nav iedarbības",
  "item.minecraft.glass_bottle": "stikla pudele",
  "item.minecraft.spider_eye": "zirnekļa acs",
  "item.minecraft.fermented_spider_eye": "fermentēta zrinekļa acs",
  "item.minecraft.blaze_powder": "liesmu pulveris",
  "item.minecraft.magma_cream": "magmas krēms",
  "block.minecraft.brewing_stand": "brūvēšanas statīvs",
  "block.minecraft.cauldron": "katls",
  "item.minecraft.ender_eye": "ender acs",
  "item.minecraft.glistering_melon_slice": "mirdzoša arbūza šķēle",
  "item.minecraft.bat_spawn_egg": "sikspārņa radīšanas ola",
  "item.minecraft.bee_spawn_egg": "bites radīšanas ola",
  "item.minecraft.blaze_spawn_egg": "liesmekļa radīšanas ola",
  "item.minecraft.cat_spawn_egg": "kaķa radīšanas ola",
  "item.minecraft.cave_spider_spawn_egg": "alu zirnekļa radīšanas ola",
  "item.minecraft.chicken_spawn_egg": "vistas radīšanas ola",
  "item.minecraft.cod_spawn_egg": "mencas radīšanas ola",
  "item.minecraft.cow_spawn_egg": "govs radīšanas ola",
  "item.minecraft.creeper_spawn_egg": "krīpera radīšanas ola",
  "item.minecraft.dolphin_spawn_egg": "delfīna radīšanas ola",
  "item.minecraft.donkey_spawn_egg": "ēzeļa radīšanas ola",
  "item.minecraft.drowned_spawn_egg": "slīkoņa radīšanas ola",
  "item.minecraft.elder_guardian_spawn_egg": "vecākā sarga radīšanas ola",
  "item.minecraft.enderman_spawn_egg": "endermena radīšanas ola",
  "item.minecraft.endermite_spawn_egg": "endermīta radīšanas ola",
  "item.minecraft.evoker_spawn_egg": "evokera radīšanas ola",
  "item.minecraft.fox_spawn_egg": "lapsas radīšanas ola",
  "item.minecraft.ghast_spawn_egg": "ghasta radīšanas ola",
  "item.minecraft.guardian_spawn_egg": "sarga radīšanas ola",
  "item.minecraft.hoglin_spawn_egg": "hoglina radīšanas ola",
  "item.minecraft.horse_spawn_egg": "zirga radīšanas ola",
  "item.minecraft.husk_spawn_egg": "huska radīšanas ola",
  "item.minecraft.llama_spawn_egg": "lamas radīšanas ola",
  "item.minecraft.magma_cube_spawn_egg": "magmas kuba radīšanas ola",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom radīšanas ola",
  "item.minecraft.mule_spawn_egg": "mūļa radīšanas ola",
  "item.minecraft.ocelot_spawn_egg": "ocelota radīšanas ola",
  "item.minecraft.panda_spawn_egg": "pandas radīšanas ola",
  "item.minecraft.parrot_spawn_egg": "papagaiļa radīšanas ola",
  "item.minecraft.phantom_spawn_egg": "fantoma radīšanas ola",
  "item.minecraft.pig_spawn_egg": "cūkas radīšanas ola",
  "item.minecraft.piglin_spawn_egg": "piglina radīšanas ola",
  "item.minecraft.pillager_spawn_egg": "laupītāja radīšanas ola",
  "item.minecraft.polar_bear_spawn_egg": "polārlāča radīšanas ola",
  "item.minecraft.pufferfish_spawn_egg": "pūšļa zivs radīšanas ola",
  "item.minecraft.rabbit_spawn_egg": "truša radīšanas ola",
  "item.minecraft.ravager_spawn_egg": "briesmoņa radīšanas ola",
  "item.minecraft.salmon_spawn_egg": "laša radīšanas ola",
  "item.minecraft.sheep_spawn_egg": "aitas radīšanas ola",
  "item.minecraft.shulker_spawn_egg": "šulkera radīšanas ola",
  "item.minecraft.silverfish_spawn_egg": "sudrabzivs radīšanas ola",
  "item.minecraft.skeleton_spawn_egg": "skeleta radīšanas ola",
  "item.minecraft.skeleton_horse_spawn_egg": "zirga skeleta radīšanas ola",
  "item.minecraft.slime_spawn_egg": "gļotas radīšanas ola",
  "item.minecraft.spider_spawn_egg": "zirnekļa radīšanas ola",
  "item.minecraft.squid_spawn_egg": "kalmāra radīšanas ola",
  "item.minecraft.stray_spawn_egg": "nomaldījies skeleta radīšanas ola",
  "item.minecraft.strider_spawn_egg": "lavas ceļotāja radīšanas ola",
  "item.minecraft.trader_llama_spawn_egg": "tirgotāja lamas radīšanas ola",
  "item.minecraft.tropical_fish_spawn_egg": "tropu zivs radīšanas ola",
  "item.minecraft.turtle_spawn_egg": "bruņurupuča radīšanas ola",
  "item.minecraft.vex_spawn_egg": "veksa radīšanas ola",
  "item.minecraft.villager_spawn_egg": "ciema iedzīvotāja radīšanas ola",
  "item.minecraft.vindicator_spawn_egg": "vindikatora radīšanas ola",
  "item.minecraft.wandering_trader_spawn_egg": "klaiņojoša tirgotāja radīšanas ola",
  "item.minecraft.witch_spawn_egg": "raganas radīšanas ola",
  "item.minecraft.wither_skeleton_spawn_egg": "wither skeleta radīšanas ola",
  "item.minecraft.wolf_spawn_egg": "vilka radīšanas ola",
  "item.minecraft.zoglin_spawn_egg": "zoglina radīšanas ola",
  "item.minecraft.zombie_spawn_egg": "zombija radīšanas ola",
  "item.minecraft.zombie_horse_spawn_egg": "zirga zombija radīšanas ola",
  "item.minecraft.zombie_villager_spawn_egg": "zombija ciema iedzīvotāja radīšanas ola",
  "item.minecraft.zombified_piglin_spawn_egg": "zombificēta piglina radīšanas ola",
  "item.minecraft.experience_bottle": "burvestību pudele",
  "item.minecraft.fire_charge": "ugunsbumba",
  "item.minecraft.writable_book": "grāmata un spalva",
  "item.minecraft.written_book": "sarakstīta grāmata",
  "item.minecraft.emerald": "smaragds",
  "item.minecraft.item_frame": "priekšmetu rāmis",
  "block.minecraft.flower_pot": "puķupods",
  "item.minecraft.carrot": "burkāns",
  "item.minecraft.potato": "kartupelis",
  "item.minecraft.baked_potato": "cepts katrupelis",
  "item.minecraft.poisonous_potato": "indīgs kartupelis",
  "item.minecraft.map": "tukša karte",
  "item.minecraft.golden_carrot": "zelta burkāns",
  "block.minecraft.skeleton_skull": "skeleta gavlaskauss",
  "block.minecraft.wither_skeleton_skull": "wither skeleta galvaskauss",
  "block.minecraft.player_head": "spēlētāja galva",
  "block.minecraft.zombie_head": "zombija galva",
  "block.minecraft.creeper_head": "krīpera galva",
  "block.minecraft.dragon_head": "pūķa galva",
  "item.minecraft.carrot_on_a_stick": "burkāns uz kociņa",
  "item.minecraft.warped_fungus_on_a_stick": "dīvaina sēne uz nūjas",
  "item.minecraft.nether_star": "nether zvaigzne",
  "item.minecraft.pumpkin_pie": "ķirbju pīrāgs",
  "item.minecraft.firework_rocket": "salūta raķete",
  "item.minecraft.firework_star": "salūta zvaigzne",
  "item.minecraft.enchanted_book": "uzlabota grāmata",
  "item.minecraft.nether_brick": "nether ķieģeļi",
  "item.minecraft.quartz": "nether kvarcs",
  "item.minecraft.tnt_minecart": "vagons ar dinamītu",
  "item.minecraft.hopper_minecart": "vagons ar piltuvi",
  "item.minecraft.prismarine_shard": "prismarīna lauska",
  "item.minecraft.prismarine_crystals": "prismarīna kristāli",
  "item.minecraft.rabbit": "jēla truša gaļa",
  "item.minecraft.cooked_rabbit": "cepta truša gaļa",
  "item.minecraft.rabbit_stew": "truša zupa",
  "item.minecraft.rabbit_foot": "truša kāja",
  "item.minecraft.rabbit_hide": "truša āda",
  "item.minecraft.armor_stand": "bruņu statīvs",
  "item.minecraft.iron_horse_armor": "dzelzs zirgu bruņas",
  "item.minecraft.golden_horse_armor": "zelta zirgu bruņas",
  "item.minecraft.diamond_horse_armor": "dimanta zirgu bruņas",
  "item.minecraft.leather_horse_armor": "ādas zirgu bruņas",
  "item.minecraft.lead": "pavada",
  "item.minecraft.name_tag": "birka",
  "item.minecraft.command_block_minecart": "vagons ar komandu bloku",
  "item.minecraft.mutton": "jēla aitas gaļa",
  "item.minecraft.cooked_mutton": "cepta aitas gaļa",
  "block.minecraft.white_banner": "balts banners",
  "block.minecraft.orange_banner": "oranžs baneris",
  "block.minecraft.magenta_banner": "gaiši violets baneris",
  "block.minecraft.light_blue_banner": "gaiši zils baneris",
  "block.minecraft.yellow_banner": "dzeltens baneris",
  "block.minecraft.lime_banner": "laima krāsas baneris",
  "block.minecraft.pink_banner": "rozā baneris",
  "block.minecraft.gray_banner": "pelēks baneris",
  "block.minecraft.light_gray_banner": "gaiši pelēks baneris",
  "block.minecraft.cyan_banner": "ciāna baneris",
  "block.minecraft.purple_banner": "violēts baneris",
  "block.minecraft.blue_banner": "zils baneris",
  "block.minecraft.brown_banner": "brūns baneris",
  "block.minecraft.green_banner": "zaļš baneris",
  "block.minecraft.red_banner": "sarkans baneris",
  "block.minecraft.black_banner": "melns baneris",
  "item.minecraft.end_crystal": "end kristāls",
  "item.minecraft.chorus_fruit": "kora auglis",
  "item.minecraft.popped_chorus_fruit": "kausēts kora auglis",
  "item.minecraft.beetroot": "biete",
  "item.minecraft.beetroot_seeds": "biešu sēklas",
  "item.minecraft.beetroot_soup": "biešu zupa",
  "item.minecraft.dragon_breath": "pūķa elpa",
  "item.minecraft.splash_potion": "šļakstoša, neizveidojama dzira□nav iedarbības",
  "item.minecraft.spectral_arrow": "spektrālā bulta",
  "item.minecraft.tipped_arrow": "neizveidojama apcirsta bulta□nav iedarbības",
  "item.minecraft.lingering_potion": "ilgstoša neuztaisāma dzira□nav iedarbības",
  "item.minecraft.shield": "vairogs",
  "item.minecraft.elytra": "spārni",
  "item.minecraft.spruce_boat": "egles laiva",
  "item.minecraft.birch_boat": "bērza laiva",
  "item.minecraft.jungle_boat": "džungļu koka laiva",
  "item.minecraft.acacia_boat": "akācijas laiva",
  "item.minecraft.dark_oak_boat": "tumšā ozolkoka laiva",
  "item.minecraft.totem_of_undying": "nemirstības totēms",
  "item.minecraft.shulker_shell": "šulkera čaula",
  "item.minecraft.iron_nugget": "dzelzs gabals",
  "item.minecraft.knowledge_book": "zināšanu grāmata",
  "item.minecraft.debug_stick": "atkļūdošanas kociņš",
  "item.minecraft.music_disc_13": "mūzikas plate□c418 - 13",
  "item.minecraft.music_disc_cat": "mūzikas plate□c418 - cat",
  "item.minecraft.music_disc_blocks": "mūzikas plate□c418 - blocks",
  "item.minecraft.music_disc_chirp": "mūzikas plate□c418 - chirp",
  "item.minecraft.music_disc_far": "mūzikas plate□c418 - far",
  "item.minecraft.music_disc_mall": "mūzikas plate□c418 - mall",
  "item.minecraft.music_disc_mellohi": "mūzikas plate□c418 - mellohi",
  "item.minecraft.music_disc_stal": "mūzikas plate□c418 - stal",
  "item.minecraft.music_disc_strad": "mūzikas plate□c418 - strad",
  "item.minecraft.music_disc_ward": "mūzikas plate□c418 - ward",
  "item.minecraft.music_disc_11": "mūzikas plate□c418 - 11",
  "item.minecraft.music_disc_wait": "mūzikas plate□c418 - wait",
  "item.minecraft.music_disc_pigstep": "mūzikas plate□lena raine - pigstep",
  "item.minecraft.trident": "trijžuburis□□kad galvenajā rokā:□+8 bojājums□-2.9 uzbrukuma ātrums",
  "item.minecraft.phantom_membrane": "fantoma membrāna",
  "item.minecraft.nautilus_shell": "nautilus čaula",
  "item.minecraft.heart_of_the_sea": "jūras sirds",
  "item.minecraft.crossbow": "arbalets",
  "item.minecraft.suspicious_stew": "aizdomīgs sautējums",
  "block.minecraft.loom": "stelles",
  "item.minecraft.flower_banner_pattern": "karoga raksts□zieds",
  "item.minecraft.creeper_banner_pattern": "karoga raksts□krīpers",
  "item.minecraft.skull_banner_pattern": "karoga raksts□galvaskauss",
  "item.minecraft.mojang_banner_pattern": "karoga raksts□lieta",
  "item.minecraft.globe_banner_pattern": "karoga raksts□globuss",
  "item.minecraft.piglin_banner_pattern": "karoga modelis□snuķis",
  "block.minecraft.composter": "kompostētājs",
  "block.minecraft.barrel": "muca",
  "block.minecraft.smoker": "kūpinātājs",
  "block.minecraft.blast_furnace": "domnas krāsns",
  "block.minecraft.cartography_table": "kartogrāfijas galds",
  "block.minecraft.fletching_table": "bultu kalšanas galds",
  "block.minecraft.grindstone": "galoda",
  "block.minecraft.lectern": "lektora galds",
  "block.minecraft.smithing_table": "kalēja galds",
  "block.minecraft.stonecutter": "akmeņkalis",
  "block.minecraft.bell": "zvans",
  "block.minecraft.lantern": "laterna",
  "block.minecraft.soul_lantern": "dvēseļu laterna",
  "item.minecraft.sweet_berries": "saldās ogas",
  "block.minecraft.campfire": "ugunskurs",
  "block.minecraft.soul_campfire": "dvēseļu ugunskurs",
  "block.minecraft.shroomlight": "sēnesgaisma",
  "item.minecraft.honeycomb": "medus šūna",
  "block.minecraft.bee_nest": "bišu pūznis",
  "block.minecraft.beehive": "bišu strops",
  "item.minecraft.honey_bottle": "medus pudele",
  "block.minecraft.honey_block": "medus bloks",
  "block.minecraft.honeycomb_block": "medus šūnu bloks",
  "block.minecraft.lodestone": "gaismas akmens",
  "block.minecraft.netherite_block": "nezerīta bloks",
  "block.minecraft.ancient_debris": "senie gruveši",
  "block.minecraft.target": "mērķis",
  "block.minecraft.crying_obsidian": "raudošais obsidiāns",
  "block.minecraft.blackstone": "melnakmens",
  "block.minecraft.blackstone_slab": "melnakmens plāksne",
  "block.minecraft.blackstone_stairs": "melnakmens kāpnes",
  "block.minecraft.gilded_blackstone": "apzeltīts melnakmens",
  "block.minecraft.polished_blackstone": "pulēts melnakmens",
  "block.minecraft.polished_blackstone_slab": "pulēta melnakmens plāksne",
  "block.minecraft.polished_blackstone_stairs": "pulēta melnakmens kāpnes",
  "block.minecraft.chiseled_polished_blackstone": "slīpēts pulēts melnakmens",
  "block.minecraft.polished_blackstone_bricks": "pulēti melnakmens ķieģeļi",
  "block.minecraft.polished_blackstone_brick_slab": "pulēta melnakmens ķieģeļu plāksne",
  "block.minecraft.polished_blackstone_brick_stairs": "pulēta melnakmens ķieģeļu kāpnes",
  "block.minecraft.cracked_polished_blackstone_bricks": "ieplaisājuši pulēti melnakmens ķieģeļi",
  "block.minecraft.respawn_anchor": "atdzimšanas enkurs",
}
export const lv_lv = items; 
